import { FC } from "react";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";

import { Message } from "../../common";
import { useFormErrors } from "../../../hooks/useFormErrors";
import { UIStatus } from "../../../types/GlobalTypes";

type Props = {
  className?: string;
  isError: boolean;
  error: FetchBaseQueryError | SerializedError | undefined;
};

export const FormErrorMessage: FC<Props> = ({ className, isError, error }) => {
  const errors = useFormErrors(isError, error);

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {errors.map((err: string) => (
        <Message type={UIStatus.ERROR} text={err} key={err} />
      ))}
    </div>
  );
};
